import React, { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getCorporateJobById, multiDownloadDocument } from "../../Redux/Actions/jobs";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";
import LoadingButton from "../../utils/loadingButton";
import { toastMessage } from "../../utils/toast";
import { downloadDocument } from "../../Redux/Actions/jobs"
import { biometricRecieptDownalod, downloadPaymentVoucher } from "../../Redux/Actions/jobs"
import { useTranslation } from "react-i18next";
import { userData } from "../../Redux/Actions/user";
import { useSelector } from "react-redux";


const DisplayConatiner = ({ label, value }) => (
  <div
    className="form-group fv-plugins-icon-container"
    style={{
      marginBottom: "10px",
      paddingBottom: "5px",
      borderBottom: "1px solid #f1f5fa",
    }}
  >
    <span className="text-muted">{label} : </span>
    {value}
  </div>
);

function Info({history}) {
  const { id } = useParams();

  //   const { t } = useTranslation();
  const [pageLoading, setPageLoading] = useState(false);
  const [downloadButtonloading, setDownloadButtonLoading] = useState({});
  // const [jobCreateButtonloading, setJobCreateButtonLoading] = useState({});
  const [jobDetail, setJobDetail] = useState({});
  const { t } = useTranslation();
  const userData = useSelector(({ User }) => User.data);

  const displayData = [
    { label: "Job Reference", value: jobDetail?.corporateJobReference },
    { label: "Job count", value: jobDetail?.jobCount },
    { label: "Department name", value: jobDetail?.departmentName },
    { label: "Master process name", value: jobDetail?.masterProcessName },
    { label: "Process name", value: jobDetail?.processName },
    { label: "Payment Type", value: jobDetail?.paymentTypeValue },
    { label: "Payment status", value: jobDetail?.paymentStatus },
    { label: "Payment completed date", value: jobDetail?.paymentCompletedDate },
    { label: "Po Number", value: jobDetail?.poNumber }
  ];

  useEffect(() => {
    if (id) {
      getCorporateJobByIdApi(id);
    }
  }, [id]);

  const getCorporateJobByIdApi = async (id) => {
    setPageLoading(true);
    try {
      const res = await apiWrapWithErrorWithData(getCorporateJobById(id));
      const response = res.data;
      setJobDetail(response?.data);
    } catch (error) {
      console.log("getCorporateJobByIdApi:", error);
    }
    setPageLoading(false);
  };

  const handleDownload = (documentIds, index, documentName) => {
    const userId = 2;
    const payload = documentIds.map(documentId => ({
      userId,
      documentId
    }));
    handleDownloadDocument(payload, index, documentName);
  };


  const handleDownloadDocument = async (payload, i, documentName) => {
    setDownloadButtonLoading((preState) => ({ ...preState, [i]: true }));
    try {
      const response = await multiDownloadDocument(payload);
      let binary_string = window.atob(response.data.content);
      let len = binary_string.length;
      let bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      let blob = new Blob([bytes], { type: response.data.contentType });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = documentName;
      link.click();
    } catch (error) {
      console.log("handleDownloadDocument", error);
    }
    setDownloadButtonLoading((preState) => ({ ...preState, [i]: false }));
  };

  const biometricRecieptDownalodClick = async (applicationNo, i, documentName, jobId) => {
    setDownloadButtonLoading((preState) => ({ ...preState, [i]: true }));
    try {
      let res = await apiWrapWithErrorWithData(biometricRecieptDownalod(applicationNo, null));
       if (res.data.value == "No completed payment found for this appointment.") {
            res = await apiWrapWithErrorWithData(biometricRecieptDownalod(null, jobId));
       }
      let binary_string = window.atob(res.data.fileContents);
      let len = binary_string.length;
      let bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      let blob = new Blob([bytes], { type: res.data.contentType });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = documentName;
      link.click();
      setDownloadButtonLoading((preState) => ({ ...preState, [i]: false }));
    } catch (error) {
      setDownloadButtonLoading((preState) => ({ ...preState, [i]: false }));
      console.log("biometricRecieptDownalodClick", error);
      toastMessage("error", "Failed to download biometric receipt");
    }
  }

  const handleDownloadVoucher = async (jobId) => {
      try {
        const response = await apiWrapWithErrorWithData(downloadPaymentVoucher(jobId));
        if(response.message) {
          console.log("handleDownloadVoucher - no voucher", response.message);
          toastMessage('error', 'No voucher available for download');
          return;
        }
        const url = window.URL.createObjectURL(new Blob([response])) ?? null;
        const link = document.createElement('a');
        link.href = url;
        console.log("handleDownloadVoucher", url, link);
        link.setAttribute('download', `payment_voucher_${jobId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        toastMessage('success', 'Payment voucher downloaded successfully');
      } catch (error) {
        console.log("handleDownloadVoucher", error);
        toastMessage('error', 'Failed to download payment voucher');
      }
    };

  return (
    <div className="container-fluid">
      <h4 className="py-3">Corporate Jobs Details</h4>
      {pageLoading ? (
        <div className="d-flex align-items-center justify-content-center h-75vh">
          <Loader
            type="ThreeDots"
            color="#2d207d"
            height={40}
            width={40}
            style={{ textAlign: "center" }}
          />
        </div>
      ) : (
        <div className="row col-lg-12">
          <div className="card card-custom card-stretch gutter-b p-2">
            <div className="p-2">
              {displayData.map(({ label, value }) => (
                <DisplayConatiner key={label} label={label} value={value} />
              ))}
            </div>
            <hr className="hr-dashed" />
            <h4 className="py-3">Corporate Jobs Document</h4>
            {(jobDetail.paymentStatus === "Completed") && userData.Role === 'COMPANY' && (
              <>
             <button
              className="json-button btn btn-sm btn-info m-2 w-25 align-self-end"
              onClick={() => handleDownloadVoucher(jobDetail.id)}
            >
              {t("eidBasmati.downloadVoucher")}
            </button>
              </>
            )}
            {jobDetail.corporateCompanyJobDocuments && jobDetail.corporateCompanyJobDocuments.length ? (
              jobDetail.corporateCompanyJobDocuments.every(doc =>
                Array.isArray(doc.documentIds) &&
                doc.documentIds.every(id => id === null)
              ) ? (
                <div>
                  <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                    <thead>
                      <tr className="text-center">
                        <th>{t("eidBasmati.applicationNo")}</th>
                        <th>{t("eidBasmati.applicantName")}</th>
                        <th>{t("eidBasmati.applicantEmail")}</th>
                        <th>{t("eidBasmati.applicantMobile")}</th>
                        <th>{t("eidBasmati.action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobDetail.corporateCompanyJobDocuments.map((doc, i) => (
                        <tr key={i} className="text-center">
                          <td>{doc.applicationNo || "-"}</td>
                          <td>{doc.applicationName || "-"}</td>
                          <td>{doc.applicationEmail || "-"}</td>
                          <td>{doc.applicationMobile || "-"}</td>
                          <td>
                            {jobDetail.paymentStatus === "Completed" ? (
                               <LoadingButton
                              style={{ margin: "1rem" }}
                              isLoading={downloadButtonloading[i]}
                              onChange={() => biometricRecieptDownalodClick(doc.applicationNo, i, `Biometric_Receipt_${doc.applicationNo || ''}`, doc.jobRequestId)}
                            >
                              Download Biometric Receipt{" "}
                            </LoadingButton>
                            ) : (
                              <span>Payment not completed</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div>
                  <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                    <thead>
                      <tr className="text-center" >
                        <th>{t("eidBasmati.documentName")}</th>
                        <th>{t("eidBasmati.passportNo")}</th>
                        <th>Job Request Id</th>
                        <th>{t("eidBasmati.action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobDetail.corporateCompanyJobDocuments.map((doc, i) => (
                        <tr key={doc.documentId || i} className="text-center">
                          <td>
                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{doc.documentName}</span>
                          </td>
                          <td>
                            {doc.passportNo ? (
                              <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{doc.passportNo}</span>
                            ) :
                              <span className="text-dark-75 font-weight-bolder d-block font-size-lg">-</span>
                            }
                          </td>
                          <td>
                            {doc.jobRequestId ? (
                              <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{doc.jobRequestId}</span>
                            ) :
                              <span className="text-dark-75 font-weight-bolder d-block font-size-lg">-</span>
                            }
                          </td>
                          <td>
                            <LoadingButton
                              style={{ margin: "1rem" }}
                              isLoading={downloadButtonloading[i]}
                              onChange={() => handleDownload(doc.documentIds, i, doc.documentName)}
                            >
                              Download document{" "}
                            </LoadingButton>
                            {doc.jobRequestId &&
                            <button
                              className="json-button btn btn-sm btn-primary m-2"
                              onClick={() => history.push(`/job-detail/${doc.jobRequestId}`)}
                            >
                              {"Veiw"}
                            </button>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            ) : (
              <h6>No documents available</h6>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Info;
